import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrMaternityLeaveEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import {
    handleDateEventEndDefaultingOnChange,
    handleEntitlementChange
} from "@pages/payroll/socialEvents/SocialEvents.utils";
import { SocialEventsFormViewForExtend } from "@pages/payroll/socialEvents/SocialEventsFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class MaternityLeaveFormView extends SocialEventsFormViewForExtend<IPrMaternityLeaveEventEntity> {
    typeCode = PrSocialEventTypeCode.MaternityLeave;

    handleChange = (e: ISmartFieldChange): void => {
        const { storage } = this.props;

        // before change to have access to orig value
        handleDateEventEndDefaultingOnChange(storage, e, 28);

        super.handleChange(e);

        // after super, because we need to have updated data in storage for handleEntitlementChange
        handleEntitlementChange(this.props.storage, e);
    }
}

export default withPermissionContext(withConfirmationDialog(MaternityLeaveFormView));